/**
 * By the business requirements the CPRA opt out page should be only in En locale
 * So we didn't move this text to copies, not to create translations by translation job
 * but to control the text content
 */
export const CPRA_COPIES = {
    SUCCESS_TOAST_MESSAGE: 'Your preferences have been successfully updated.',
    ERROR_TOAST_MESSAGE: 'Something went wrong, try again in a few minutes',
    PRIVACY_CARD_TEXT: 'For more information about how we use personal data, please see our',
    PRIVACY_CARD_LINK: 'Privacy Policy',
    HEADING: 'Do not sell or share my personal information',
    FIRST_TEXT_BLOCK_CONTENT:
        "Fiverr doesn’t share your personal info for monetary compensation. When we do share your info with our partners, it helps us tailor Fiverr’s offers, ads, and content to suit your preferences while you're browsing other sites. Just to let you know, this process may constitute selling or sharing of personal information under certain US state privacy laws.",
    SECOND_TEXT_BLOCK_CONTENT: 'You can always opt out of the selling or sharing of your personal information.',
    DISCLAIMER_TEXT_BLOCK_CONTENT:
        "If you're not logged into your Fiverr account, opting out will only apply to the browser or device you're currently using. Keep in mind that even if you opt out, you might still see generic Fiverr ads instead of personalized ones. Also, if you clear your cookies, switch to a new browser or device, you'll need to submit a new opt-out request to ensure your choice is applied again.",
    CHECKBOX_SAVE_LABEL: "Don't sell or share my personal information.",
    SAVE_BUTTON: 'Save',
    META_TITLE: 'Do not sell or share my personal information | Fiverr',
    META_DESCRIPTION:
        "Fiverr doesn't share your personal info for monetary compensation. We may share your info with our marketing partners, which helps us tailor and personalize Fiverr's offers",
};
